import { Component, OnInit, Input, HostListener, AfterViewInit, ElementRef, ChangeDetectorRef} from '@angular/core';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { AbstractControl, FormBuilder, ReactiveFormsModule, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CmElement, ContentType } from '../shared/model/cm/managed-content.model';
import { GlobalConstants } from '../shared/global-constants';
import { DropDown } from '../shared/model/drop-down';
import { MhsService } from '../shared/service/mhs.service';
import { FormControlUtilitiesService } from '../shared/service/form-control-utilities.service';
import { UserSessionService } from '../shared/service/user-session.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';


@Component({
  selector: 'app-month-picker',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MonthPickerComponent implements OnInit, AfterViewInit {
  @Input() questionNumber: string;
  @Input() label: string;
  @Input() parentForm: UntypedFormGroup;

  public dropdownWidth: number;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.dropdownWidth = document.getElementById(this.monthName).clientWidth;
  }

  @HostListener('window:load',['$event'])
  onPageLoad(event: Event) {
    this.dropdownWidth = document.getElementById(this.monthName).clientWidth;
  }

  public monthName: string;
  public yearName: string;
  public deleteControls: boolean = false;

  public selectedTextMonth: string = 'Month Diagnosed';
  public selectedTextYear: string = 'Year Diagnosed';
  private formNumber: string = this.userSessionService.data.formNumber;
  public isGenericDynamicForm: boolean = this.userSessionService.data.isGenericDynamicForm;

  requiredElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'required-error');
  futureDatedElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'future-dated-error');
  futureDatedPregnancyElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'future-dated-pregnancy-error');
  backDatedPregnancyElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'back-dated-pregnancy-error');
  backDatedResolutionElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'back-dated-resolution-error');

  monthYear: string;

  requiredError: string;

  public isPregnancyQuestion: boolean = false;
  public isResolutionDateQuestion: boolean = false;

  public monthList: Array<DropDown> = GlobalConstants.MONTHS;
  public months: Array<string> = GlobalConstants.MONTHS.map(m => m.label);
  public years: Array<string> = [];
  public pregnancyYearList: Array<DropDown>;
  public pregnancyYears: Array<string> = [];
  public lastdateOfVisit: boolean = false;
  monthElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-diagnosed');
  yearElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-diagnosed');
  lastVisitDateElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT,'date-last-visit');

  constructor(private cmService: ManagedContentService,
    private fb: FormBuilder,
    private mhsService: MhsService,
    public formControlUtilitiesService: FormControlUtilitiesService,
    private el:ElementRef,
    private userSessionService: UserSessionService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if(this.label == 'Date of Last Seizure'){
      this.monthElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-seizure');

      this.selectedTextMonth = this.monthElement.label;
      this.months.unshift(this.monthElement.label);

      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-seizure');
      this.selectedTextYear = this.yearElement.label;
      if(this.years[0] != this.yearElement.label){
        this.years.unshift(this.yearElement.label);
      }
    } else if(this.label == 'Expected Date of Delivery' || this.label == 'Due Date'){
      this.monthElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-delivery');

      this.selectedTextMonth = this.monthElement.label;
      this.months.unshift(this.monthElement.label);

      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-delivery');
      this.selectedTextYear = this.yearElement.label;
      if(this.years[0] != this.yearElement.label){
        this.years.unshift(this.yearElement.label);
      }
    } else if(this.label == 'Date of Onset'|| this.label == 'Date of Onset (Start)'){
      this.monthElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-onset');

      this.selectedTextMonth = this.monthElement.label;
      this.months.unshift(this.monthElement.label);

      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-onset');
      this.selectedTextYear = this.yearElement.label;
      if(this.years[0] != this.yearElement.label){
        this.years.unshift(this.yearElement.label);
      }
    } else if(this.label == 'Date of Resolution' || this.label == 'Date of Resolution (End)'){
      this.monthElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-resolution');

      this.selectedTextMonth = this.monthElement.label;
      this.months.unshift(this.monthElement.label);

      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-resolution');
      this.selectedTextYear = this.yearElement.label;
      if(this.years[0] != this.yearElement.label){
        this.years.unshift(this.yearElement.label);
      }
    } else if(this.label == 'Last date of visit'){
      this.lastdateOfVisit = true;
      this.monthElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-of-last-visit');

      this.selectedTextMonth = this.lastVisitDateElement.label;
      this.months.unshift(this.monthElement.label);

      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-of-last-visit');
      this.selectedTextYear = this.yearElement.label;
      if(this.years[0] != this.yearElement.label){
        this.years.unshift(this.yearElement.label);
      }
    } else {
      this.selectedTextMonth = 'Month Diagnosed';
      this.months.unshift('Month Diagnosed');

      this.selectedTextYear = 'Year Diagnosed';
      if(this.years[0] != 'Year Diagnosed'){
        this.years.unshift('Year Diagnosed');
      }
    }
    
    this.checkForPregnancyQuestion();
    this.populateYearList();
    this.populatePregnancyYearList();

    this.loadErrorMessages();
    
    this.monthName = this.questionNumber + "-month";
    this.yearName = this.questionNumber + "-year";
    if(this.lastdateOfVisit){
      this.monthName = "physicianLastVisitMonthName";
      this.yearName = "physicianLastVisitYearName";
    }

    if(this.parentForm){
      // Only add controls if they don't already exist (prevents overwriting existing values)
      if(this.lastdateOfVisit){
        if (!this.parentForm.contains(this.monthName)) {
          this.parentForm.addControl(this.monthName, this.fb.control('', [Validators.required]));
        }
        if (!this.parentForm.contains(this.yearName)) {
          this.parentForm.addControl(this.yearName, this.fb.control('', [Validators.required]));
        }
      }else{
        if (!this.parentForm.contains(this.monthName)) {
          this.parentForm.addControl(this.monthName, this.fb.control('', [Validators.required]));
        }
        if (!this.parentForm.contains(this.yearName)) {
          this.parentForm.addControl(this.yearName, this.fb.control('', [Validators.required]));
        }
        if (!this.parentForm.contains(this.questionNumber)) {
          // Custom validator that checks if both month and year are empty
          this.parentForm.addControl(this.questionNumber, this.fb.control('', [this.validateCombinedDate.bind(this)]));
        }
      }
    }

    // Individual controls no longer need validators since we manage all validation
    // through the combined questionNumber control
    // EXCEPTION: For last date of visit, we DO need validators on individual controls
    // because there is no combined questionNumber control
    if(this.parentForm && !this.lastdateOfVisit){
      this.parentForm.get(this.monthName).clearValidators();
      this.parentForm.get(this.yearName).clearValidators();
      this.parentForm.get(this.monthName).updateValueAndValidity();
      this.parentForm.get(this.yearName).updateValueAndValidity();
    }

    if(this.label == 'Date of Last Seizure'){
      this.monthElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-seizure');
      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-seizure');
    } else if(this.label == 'Expected Date of Delivery' || this.label == 'Due Date'){
      this.monthElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-delivery');
      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-delivery');
    } else if(this.label == 'Date of Onset' || this.label == 'Date of Onset (Start)'){
      this.monthElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-onset');
      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-onset');
    } else if(this.label == 'Date of Resolution' || this.label == 'Date of Resolution (End)'){
      this.monthElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-resolution');
      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-resolution');
    } else if(this.label == 'Last date of visit'){
      this.monthElement = this.cmService.getContentById(ContentType.ELEMENT, 'month-of-last-visit');
      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-of-last-visit');
    }

    if(this.mhsService){
      this.mhsService.deletingControls.subscribe( v => {
        if(v === true){
          this.deleteControls = true;
        };
        if(v === false){
          this.deleteControls = false;
        };
      });
      
      this.mhsService.isPregnancyQuestionControl.subscribe( index => {
        this.isPregnancyQuestion = index;
      });   
    }
  }

  ngAfterViewInit(): void {
    this.dropdownWidth = this.el.nativeElement.offsetWidth;
    // Check if month and year values already exist (restored from session storage)
    // and trigger validation if they do
    if(this.parentForm && !this.checkIfMonthIsNullOrEmpty() && !this.checkIfYearIsNullOrEmpty()){
      // Mark as touched only when both values exist (restored after submit)
      // This ensures date validation errors show for restored invalid dates
      if(this.parentForm.contains(this.questionNumber)){
        this.parentForm.get(this.questionNumber)?.markAsTouched();
      }
      
      // Run validation
      this.checkForDateErrors();
      this.parentForm.get(this.monthName)?.updateValueAndValidity();
      this.parentForm.get(this.yearName)?.updateValueAndValidity();
    }
    
    // ADDITIONAL CHECK: Sometimes values are set AFTER ngAfterViewInit (e.g., when component recreated after parent toggle)
    // Check again after a delay to catch those cases
    setTimeout(() => {
      if(this.parentForm && !this.checkIfMonthIsNullOrEmpty() && !this.checkIfYearIsNullOrEmpty()){
        // Only mark combined control as touched
        // this.parentForm.get(this.monthName)?.markAsTouched();
        // this.parentForm.get(this.yearName)?.markAsTouched();
        if(this.parentForm.contains(this.questionNumber)){
          this.parentForm.get(this.questionNumber)?.markAsTouched();
        }
        
        // Run validation
        this.checkForDateErrors();
        this.parentForm.get(this.monthName)?.updateValueAndValidity();
        this.parentForm.get(this.yearName)?.updateValueAndValidity();
        
        // Log the validation state
      } else {
      }
    }, 250);
  }

  // ngOnDestroy removed - empty lifecycle methods violate linting rules
  // DO NOT remove controls from parent form - this causes data loss during navigation
  // The parent form should manage its own controls' lifecycle

  // Custom validator for the combined date control
  validateCombinedDate(): ValidationErrors | null {
    if (!this.parentForm) return null;
    
    const monthEmpty = this.checkIfMonthIsNullOrEmpty();
    const yearEmpty = this.checkIfYearIsNullOrEmpty();
    
    // If both fields are filled, validate the date immediately (show errors right away)
    if (!monthEmpty && !yearEmpty) {
      const validationResult = this.validateMonthAndYear();
      if (validationResult === 'backDatedPregnancy') {
        return { backDatedPregnancy: true };
      } else if (validationResult === 'futureDated') {
        return { futureDated: true };
      } else if (validationResult === 'backDatedResolution') {
        return { backDatedResolution: true };
      }
      // Both filled and valid date - no error
      return null;
    }
    
    // Required validations - always return errors if fields are empty
    // The HTML template will control when to display these using the touched state
    // If both fields are empty, return required error
    if (monthEmpty && yearEmpty) {
      return { required: true };
    }
    
    // If only month is filled (year empty), return yearRequired error
    if (!monthEmpty && yearEmpty) {
      return { yearRequired: true };
    }
    
    // If only year is filled (month empty), return monthRequired error
    if (monthEmpty && !yearEmpty) {
      return { monthRequired: true };
    }
    
    // Should never reach here, but return null as fallback
    return null;
  }

  public checkIfMonthIsNullOrEmpty(){
    if(this.parentForm){
      if(this.parentForm.contains(this.monthName)){
        if(this.parentForm.get(this.monthName).value == "" ||
          this.parentForm.get(this.monthName).value == null ||
          this.parentForm.get(this.monthName).value == undefined){
          return true;
        } else {
          return false;
        }
      }
    }
  }

  public checkIfYearIsNullOrEmpty(){
    if(this.parentForm){
      if(this.parentForm.contains(this.yearName)){
        const yearValue = this.parentForm.get(this.yearName).value;
        if(yearValue == "" ||
          yearValue == null ||
          yearValue == undefined ||
          isNaN(Number(yearValue))){  // Treat placeholder text (non-numeric) as empty
          return true;
        } else {
          return false;
        }
      }
    }
  }

  public validateMonth(): ValidatorFn {
    return () : ValidationErrors | null => {
      if(!this.deleteControls){
        if(this.checkIfMonthIsNullOrEmpty()){
          return {required : true};
        } else {
          let answer: string = this.validateMonthAndYear();

          if(answer === 'backDatedPregnancy'){
            // Validator should only return errors, not set them
            return {backDatedPregnancy : true};
          } else if (answer === 'futureDated'){
            // Validator should only return errors, not set them
            return {futureDated : true};
          } else if (answer === 'required'){
            // Validator should only return errors, not set them
            return {required : true};
          } else {
            // Valid - return null (no errors)
            return null;
          }
        }
      }
    }
  }

  public validateYear(): ValidatorFn {
    return () : ValidationErrors | null => {
      if(!this.deleteControls){
        if(this.checkIfYearIsNullOrEmpty()){
          return {required : true}
        } else {
          // Valid - return null (no errors)
          return null;
        }
      }
    }
  }

  public checkForPregnancyQuestion(){
    if(this.questionNumber == "mq-10086-deliveryDate" && !this.isGenericDynamicForm){
      this.isPregnancyQuestion = true;
    } else if(this.questionNumber == "mq-10150-deliveryDate" && this.isGenericDynamicForm){
      this.isPregnancyQuestion = true;
    }
    else {
      this.isPregnancyQuestion = false;
    }
    return false;
  }

  public checkForResolutionDateQuestion(){
    if(this.questionNumber.includes("-resolutionDate")){
      this.isResolutionDateQuestion = true;
    } 
    else {
      this.isResolutionDateQuestion = false;
    }
    return false;
  }

  // Event Handlers
  handleOptionSelectedMonth(event: Event, key: string) {

    const customEvent = event as CustomEvent;
    let optSelected = customEvent.detail;
    let optValue = this.getMonthValue(optSelected);
    if(this.parentForm){
      this.parentForm.get(key).setValue(optValue);
      // Don't mark as touched during selection - only on submit
      // This prevents required errors from showing during partial entry
      // if(this.parentForm.contains(this.questionNumber)){
      //   this.parentForm.get(this.questionNumber).markAsTouched();
      // }
    }
    // Update combined date value and check for validation errors
    this.checkForDateErrors();
    // Trigger validators on the form controls
    this.parentForm.updateValueAndValidity();
    
    // Debug: Check control states after validation
    // Trigger change detection to ensure error messages appear immediately
    this.cdr.detectChanges();
  }

  getMonthValue(optSelected: string){
    for(let month of this.monthList){
      if(month.label === optSelected){
        return month.value;
      }
    }
    // If no match found (e.g., placeholder text selected), return empty string
    // This allows required validation to work properly
    return '';
  }

  handleOptionSelectedYear(event: Event, key: string) {

    const customEvent = event as CustomEvent;
    let optSelected = customEvent.detail;
    const test = this.years.indexOf(optSelected);
    // If placeholder (index 0) is selected, set empty value to allow required validation
    if(this.years.indexOf(optSelected) == 0){
      if(this.parentForm){
        this.parentForm.get(key).setValue('');  // Set empty instead of first year
      }
    } else {
      if(this.parentForm){
        this.parentForm.get(key).setValue(optSelected);
      }
    }

    if(this.parentForm){
      // Don't mark as touched during selection - only on submit
      // This prevents required errors from showing during partial entry
      // if(this.parentForm.contains(this.questionNumber)){
      //   this.parentForm.get(this.questionNumber).markAsTouched();
      // }
    }
    // Update combined date value and check for validation errors
    this.checkForDateErrors();
    // Trigger validators on the form controls
    this.parentForm.updateValueAndValidity();
    // Trigger change detection to ensure error messages appear immediately
    this.cdr.detectChanges();
    
    // Debug: Log all values needed for error display
  }

  public getFieldLabel(optSelected: string){
    for(let month of this.monthList){
      if(month.value === optSelected){
        return month.label;
      }
    }
    return null;
  }

  public getYearFieldLabel(optSelected: string){
    // Don't render placeholder text as selected value - return null to show placeholder
    if(!optSelected || optSelected === '' || isNaN(Number(optSelected))){
      return null;
    }
    for(let year of this.years){
      if(year === optSelected){
        return year;
      }
    }
    return null;
  }
  
  public getPregnancyYearsFieldLabel(optSelected: string){
    // Don't render placeholder text as selected value - return null to show placeholder
    if(!optSelected || optSelected === '' || isNaN(Number(optSelected))){
      return null;
    }
    for(let year of this.pregnancyYears){
      if(year === optSelected){
        return year;
      }
    }
    return null;
  }

  /**
   * Check if the month field should show error styling.
   * Month field shows error icon for 'required' (both empty), 'monthRequired' (only month empty),
   * and all date validation errors (futureDated, backDated, etc.).
   * Does NOT show error icon for 'yearRequired' (that's year field's problem).
   * Date errors show immediately; required errors only show when touched.
   */
  public isMonthFieldValid(): boolean {
    // For last date of visit, check the individual month control
    if (this.lastdateOfVisit) {
      const monthControl = this.parentForm?.get(this.monthName);
      if (!monthControl) {
        return true;
      }
      // Show error if control is invalid and touched
      return !(monthControl.invalid && monthControl.touched);
    }
    
    // Regular month-picker validation logic
    if (!this.parentForm || !this.parentForm.contains(this.questionNumber)) {
      return true;
    }
    const control = this.parentForm.get(this.questionNumber);
    
    if (!control.errors) {
      return true; // No errors at all
    }
    
    const errors = control.errors;
    
    // If the ONLY error is yearRequired, month field is valid (that's year field's problem)
    if (Object.keys(errors).length === 1 && errors['yearRequired']) {
      return true;
    }
    
    // Check for date validation errors (show immediately without touched check)
    const hasDateError = errors['futureDated'] || errors['backDatedPregnancy'] || errors['backDatedResolution'];
    if (hasDateError) {
      return false; // Show date errors immediately
    }
    
    // Check for required errors (only show when touched)
    const hasRequiredError = errors['required'] || errors['monthRequired'];
    if (hasRequiredError && control.touched) {
      return false; // Show required errors only when touched
    }
    
    return true; // No relevant errors or not touched yet
  }

  /**
   * Check if the year field should show error styling.
   * Year field shows error icon for 'required' (both empty) or 'yearRequired' (only year empty) errors.
   * Date validation errors (futureDated, backDated, etc.) are shown only on month field.
   * This prevents the year field from showing an error icon with no message.
   */
  public isYearFieldValid(): boolean {
    // For last date of visit, check the individual year control
    if (this.lastdateOfVisit) {
      const yearControl = this.parentForm?.get(this.yearName);
      if (!yearControl) {
        return true;
      }
      // Show error if control is invalid and touched
      return !(yearControl.invalid && yearControl.touched);
    }
    
    // Regular month-picker validation logic
    if (!this.parentForm || !this.parentForm.contains(this.questionNumber)) {
      return true;
    }
    const control = this.parentForm.get(this.questionNumber);
    // Year field is invalid if there's a 'required' or 'yearRequired' error
    return !((control.hasError('required') || control.hasError('yearRequired')) && control.touched);
  }

  /**
   * Updates the combined date value (e.g., "05/2026") when both month and year are filled.
   * Does NOT set errors - validators handle all validation logic.
   */
  private updateCombinedDateValue(): void {
    if(!this.checkIfMonthIsNullOrEmpty() && !this.checkIfYearIsNullOrEmpty()){
      // Both month and year are filled - set the combined value
      if(this.parentForm && this.parentForm.contains(this.monthName) && this.parentForm.contains(this.yearName) && this.parentForm.contains(this.questionNumber)){
        const monthValue = this.parentForm.get(this.monthName).value;
        const yearValue = this.parentForm.get(this.yearName).value;
        this.parentForm.get(this.questionNumber).setValue(`${monthValue}/${yearValue}`);
      }
    }
  }

  public checkForDateErrors(){
    this.checkForResolutionDateQuestion();
    this.checkForPregnancyQuestion();

    const monthEmpty = this.checkIfMonthIsNullOrEmpty();
    const yearEmpty = this.checkIfYearIsNullOrEmpty();
    // Update the combined date value if both fields are filled
    if(!monthEmpty && !yearEmpty){
        this.updateCombinedDateValue();
    }
    
    // Trigger validation on the questionNumber control - the validator will handle errors
    if(this.parentForm && this.parentForm.contains(this.questionNumber)){
      this.parentForm.get(this.questionNumber).updateValueAndValidity();
    }
  }

  public validateMonthAndYear(){
    if(!this.checkIfMonthIsNullOrEmpty()){
        //check if year is null or empty
        if(!this.checkIfYearIsNullOrEmpty()){
            //both month and year are not null or empty
            let month = null;
            let year = null;
            if(this.parentForm.contains(this.monthName)){
              month = this.parentForm.get(this.monthName).value;
            }

            if(this.parentForm.contains(this.yearName)){
              year = this.parentForm.get(this.yearName).value;
            }

            let date: Date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            let selectedDate = new Date(year, month -1);//months are zero indexed
            let tenMonthsFromToday = new Date(firstDay.getFullYear(), firstDay.getMonth() + 10);

            if(this.isPregnancyQuestion){
              if(selectedDate > tenMonthsFromToday){
                return "futureDated";
              } else {
                if(selectedDate < firstDay){
                  return "backDatedPregnancy";
                } else {
                  if(this.isPregnancyQuestion){
                    //happy path
                    return null;
                  } else {
                    return 'futureDated';
                  }
                }
              }
            } else if(this.isResolutionDateQuestion){
              let queNumber = this.questionNumber.replace('-resolutionDate','');
              let onsetDateMonth = null;
              let onsetDateYear = null;
              if(this.parentForm.contains(queNumber+'-onsetDate-month')){
                onsetDateMonth = this.parentForm.get(queNumber+'-onsetDate-month').value;
              }
              if(this.parentForm.contains(queNumber+'-onsetDate-year')){
                onsetDateYear = this.parentForm.get(queNumber+'-onsetDate-year').value;
              }
              let onsetDate = new Date(onsetDateYear, onsetDateMonth -1);
              if(selectedDate < onsetDate){
                return "backDatedResolution";
              } else if(selectedDate > firstDay){
                return "futureDated";
              }
              else {
                return null;
              } 
            } else {
              if(selectedDate > firstDay){
                return "futureDated";
              }else{
                //happy path
                return null;
              }
            }
          } else {
            //year is null or empty
            return null;
        }
    } else {
      //month is null or empty
      return "required";
    }
  }

  private populateYearList(){
    let date: Date = new Date();
    let currentYear: number = date.getFullYear();

    for (let i = 0; i < 100; i++) {
      this.years.push(currentYear.toString());
      currentYear--;
    }

    if(this.label == 'Expected Date of Delivery' || this.label == 'Due Date'){
      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-delivery');
      if(this.years[0] != this.yearElement.label){
        this.years.unshift(this.yearElement.label);
      }
    } else if(this.label == 'Date of Onset' || this.label == 'Date of Onset (Start)'){
      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-onset');
      if(this.years[0] != this.yearElement.label){
        this.years.unshift(this.yearElement.label);
      }
    } else if(this.label == 'Date of Last Seizure'){
      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-seizure');
      if(this.years[0] != this.yearElement.label){
        this.years.unshift(this.yearElement.label);
      }
    } else if(this.label == 'Date of Resolution' || this.label == 'Date of Resolution (End)'){
      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-resolution');
      if(this.years[0] != this.yearElement.label){
        this.years.unshift(this.yearElement.label);
      }
    } else if(this.label == 'Last date of visit'){
      this.yearElement = this.cmService.getContentById(ContentType.ELEMENT, 'year-of-last-visit');
      if(this.years[0] != this.yearElement.label){
        this.years.unshift(this.yearElement.label);
      }
    } else {
      if(this.years[0] != 'Year Diagnosed'){
        this.years.unshift('Year Diagnosed');
      }
    }
    
  }

  private populatePregnancyYearList(){
    let date: Date = new Date();
    let currentYear: number = date.getFullYear();
    currentYear++;//forward pregnancy by one year

    for (let i = 0; i < 100; i++) {
      this.pregnancyYears.push(currentYear.toString());
      currentYear--;
    }
    
    if(this.isPregnancyQuestion){
      this.pregnancyYears.unshift('Expected Year of Delivery');
    } else {
      this.pregnancyYears.unshift('Year Diagnosed');
    }
  }

  loadErrorMessages(){
    this.requiredElement = this.cmService.getContentById(ContentType.ELEMENT, 'required-error');
  }

}
